<template>
  <div class="mb-32 mt-24 xl:mt-0">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="mb-8 text-h3 md:text-h2">Hello, {{ account.firstName }}</h1>
        <p v-if="!isBasic" class="text-body">
          <span class="capitalize">{{ accountType }}</span> member
        </p>
        <Button v-else class="p-0" variant="text" :href="upgradeLink" value="Upgrade to premium" />
      </div>
      <router-link :to="{ name: 'seeker-photo-upload' }" class="flex items-center" :aria-label="ariaLabel">
        <Avatar v-once :name="avatarName" :image-url="avatarUrl" :photo-status="account.photoStatus" :size="AvatarSize.MEGA" />
        <div class="photo-action -ml-24 self-end z-10">
          <template v-if="photoAction">
            <div class="bg-grey-background-lightgrey rounded-full p-8">
              <PhotoIcon :color="iconColor" :width="16" :height="16" />
            </div>
          </template>
          <template v-else>
            <AddIcon :width="32" :height="32" />
          </template>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">
// Components
import Avatar, { AvatarSize } from '@/components/avatar/Avatar.vue';
import Button from '@/components/button/Button.vue';

// Icons & Graphics
import AddIcon from '@/graphics/icons/AddIcon.vue';
import PhotoIcon from '@/graphics/icons/PhotoIcon.vue';

// Lib
import { Account } from '@/models/account';

export default {
  name: 'DashboardHeading',
  components: {
    Avatar,
    Button,

    AddIcon,
    PhotoIcon,
  },
  props: {
    account: { type: Account, required: true },
    dashboardData: { type: Object, required: true },
  },
  data() {
    return {
      AvatarSize,
      upgradeLink: '/upgrade/pricing',
    };
  },
  computed: {
    ariaLabel(): string {
      if (this.avatarUrl) return `Profile photo present, profile photo upload link for ${this.dashboardData.name}`;
      return `Profile photo upload link for ${this.dashboardData.name}`;
    },
    avatarName(): string {
      return this.dashboardData.display_name || this.dashboardData.name;
    },
    avatarUrl(): string {
      return this.dashboardData.photoUrl;
    },
    accountType(): string | null {
      const accountType = this.account.accountType() ?? '';
      return accountType.toString().split('_').join(' ');
    },
    isBasic(): Boolean {
      return this.account.isBasic();
    },
    iconColor(): string {
      return '#4B4C52';
    },
    photoAction(): Boolean {
      return !!this.avatarUrl;
    },
  },
};
</script>
